import functions from './functions';
import apiUrls from './apiUrls';

export default {
  ...functions,
  ...apiUrls
};